export default __webpack_public_path__ + "static/media/background_mesh.0a425edd.png";